/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent } from '../../../Shared/Card'
import { useQuery } from '@tanstack/react-query'
import { getPosDevices } from '../../../../../services/PointOfSale/PointOfSale.service'
import { TIME } from '../../../../../services/date.service'
import useUser from '../../../../Shared/UserProvider/useUser'
import { useTranslation } from 'react-i18next'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import { Icon, IconGroup } from 'semantic-ui-react'

const DevicesCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['devices', user.provider.object.id],
        queryFn: () => getPosDevices(user.provider.object.id),
        staleTime: TIME.HOUR_IN_MS * 4,
    })

    const noDevices = !isLoading && data.devicesCount === 0

    const getBorderColor = () => {
        if (isLoading) {
            return 'unset'
        }

        return noDevices ?  '#dc2626' : '#22c55e'
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};
            .card-content {
                width: 265px;
                height: 110px;
            }
        `}
      >
          <CardContent
            css={css`
                display: flex;
                column-gap: 1rem;
                justify-content: center;
                align-items: center;
                padding: ${isLoading ? '0' : '1rem'};
            `}
          >
              {isLoading ? (
                <LoadingPlaceholderCardContent/>
              ) : (
                <>
                <IconGroup size="big">
                    <Icon color="grey" name="tablet alternate"/>
                    <Icon
                      corner
                      name={noDevices ? 'ban' : 'checkmark'}
                      color={noDevices ? 'red' : 'green'}
                    />
                </IconGroup>
                <p
                  css={css`
                      font-weight: bold;
                  `}
                >
                    {noDevices ?
                      t('device.no_device_connected') :
                      t('device.count_device_connected', {count: data.devicesCount})
                    }
                </p>
                </>
                )}
            </CardContent>
        </Card>
    )
}

export {DevicesCard}
